export class SaveCustomerInput {
  email?: string;
  firstName?: string;
  lastName?: string;
  phone?: string;
  document?: string;
  password?: string;
  address: SaveCustomerAddressInput;
}

export class SaveCustomerAddressInput {
  address1?: string;
  address2?: string;
  addressNumber?: number;
  city?: string;
  neighborhood?: string;
  country?: string;
  countryCode?: string;
  province?: string;
  provinceCode?: string;
  zip?: string;
}